export default class CvBtn {

    constructor() {

        this.init();

    }

    init() {

        // お問い合わせボタンの表示／非表示の切り替え
        this.cvbtnBehavior();

    }

    cvbtnBehavior() {

        const $contact = document.querySelector('.l-contact'),
            $cvbtn = document.querySelector('.l-header__inquiry');

        if ($contact !== null && $cvbtn !== null) {

            //コンタクトボタンの交差
            window.addEventListener('scroll', () => {
                const tgt = $contact.getBoundingClientRect().top + window.pageYOffset,
                    scb = window.pageYOffset + window.innerHeight;
                if (scb >= tgt) {
                    $cvbtn.classList.add('-hide');
                } else {
                    $cvbtn.classList.remove('-hide');
                }
            });

        }

    }

}